import React  from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import '../CC/cc.css';

const Collaborations = () => {
  return (
    <div>
      
 <img src="https://static.igem.wiki/teams/4272/wiki/coll1.png" alt="hp-page-img1" 
      width={"100%"}/>
      <br/><br/>
      <br/><br/>
     <Row>
      <Col md={{offset:1}}>
      <h1 style={{color:"#0072F9" ,fontWeight:"bold"}}>Collaboration</h1>
      </Col>
      </Row>

      <br/>
<p style={{width:"85vw",marginLeft:"8vw"}}>
During this year's iGEM trip, we worked with many teams online due to the impact of the COVID-19 outbreak. We learned a lot from communicating with other team.In addition, we tried our best to use our skills to help other teams in many aspects. Especially in the areas of modeling, proof of concept, and project application, we exchanged a number of inspiration with other iGEMers.
</p>
<br/>
<Row>
      <Col md={{offset:1}}>
      <h2 style={{color:"#0072F9" ,fontWeight:"bold"}}>CCiC</h2>
      </Col>
      </Row>

      
      <br/>
<p style={{width:"85vw",marginLeft:"8vw"}}>
During August 18-22, 2022, CCiC (China iGEMer Community Conference) was successfully held at Shanghai University of Science and Technology. We attended the conference online and presented our project to other Chinese iGEM teams, meanwhile our presentation was broadcasted alive to the public through the bilibili platform. We got many suggestions and questions from experts and other teams about our project, which led us to promote further literature review and research on the application of Anti-Crispr protein.
</p>
<br/>
     <Row>
<Col md={{offset:1,span:5}}>
<img src="https://static.igem.wiki/teams/4272/wiki/coll2.png" alt="coll2" 
      width={"530vw"}/>
      <img src="https://static.igem.wiki/teams/4272/wiki/coll3.png" alt="coll3" 
      width={"530vw"}/>
</Col>

<Col>

      <img src="https://static.igem.wiki/teams/4272/wiki/coll4.png" alt="coll4" 
      width={"530vw"}/>
</Col>

     </Row>

     <br/>
<p style={{width:"85vw",marginLeft:"8vw"}}>
We also made acquaintance with SJTU_Software and SYSU_Software students at the conference and answered questions from SYSU_Software team members. The meeting strengthened the friendship between two teams and laid the foundation for our further cooperation and partnership.
</p>
<br/>

<img src="https://static.igem.wiki/teams/4272/wiki/coll5.png" alt="coll5" 
      width={"1130vw"} style={{marginLeft:"10vw"}}/>
<br/><br/>
<p style={{width:"85vw",marginLeft:"8vw"}}>
This year, DUT_China proposed an excellent project in which they developed a CRISPR-based purification system called "strainer". They also focused on multiple issues when using CRISPR/Cas system for gene editing, such as off-target cleavage, inconsistent gRNA efficiency, protospacer-adjacent motif (PAM) specificity, etc. The topics of our two teams are highly similar.Through the communication, we learned that the efficiency of high-throughput gene editing is only about 60%, and this problem leads to the prolonging of the time spending on strain construction and screening at a large consumption of human and material resources.The off-target effect is one of the main reason of this problem.
Communicating with DUT China, we further realized the application value of Anti-Crispr and firmly determined the choice of research topic.
</p>
<p style={{width:"85vw",marginLeft:"8vw"}}>
Meanwhile, we suggested to DUT_China team member that human gene SNPs could be taken into consideration when predicting off-target loci. We also provided suggestions about data processing to help them solve the problem of data imbalance in the training set.
</p>
<br/><br/>
<Row>
      <Col md={{offset:1}}>
      <h2 style={{color:"#0072F9" ,fontWeight:"bold"}}>SYSU_Software</h2>
      </Col>
      </Row>
      <br/>
      <p style={{width:"85vw",marginLeft:"8vw"}}>
      After the CCiC conference, we got in touch with SYSU_Software's students. Through the communication, we learned that SYSU_Software's project was about mining Crispr-Cas-like defense systems, which was partly related to our team's topic.SYSU_Software's suggestions helped us to optimize our model. In addition, later in the project, we provided SYSU_Software with the results of data testing and validation, which also contributed to our project validation.
In fact, the collaboration between the two teams went far beyond the scope of "Collaboration". For more information, please see <a href="https://2022.igem.wiki/tongji-software/partnership" style={{color:"grey"}}>Partnership.</a>.
</p>
<br/>
<br/>
<Row>
      <Col md={{offset:1}}>
      <h2 style={{color:"#0072F9" ,fontWeight:"bold"}}>DUT_China</h2>
      </Col>
      </Row><div id='problem_bg1'></div>
      <br/>

<img src="https://static.igem.wiki/teams/4272/wiki/coll6.png" alt="coll5" 
      width={"1130vw"} style={{marginLeft:"10vw"}}/>
<br/><br/><br/><br/>
      <p style={{width:"85vw",marginLeft:"8vw"}}>
      This year, DUT_China proposed an excellent project in which they developed a CRISPR-based purification system called "strainer". They also focused on multiple issues when using CRISPR/Cas system for gene editing, such as off-target cleavage, inconsistent gRNA efficiency, protospacer-adjacent motif (PAM) specificity, etc. The topics of our two teams are highly similar.Through the communication, we learned that the efficiency of high-throughput gene editing is only about 60%, and this problem leads to the prolonging of the time spending on strain construction and screening at a large consumption of human and material resources.The off-target effect is one of the main reason of this problem.
Communicating with DUT China, we further realized the application value of Anti-Crispr and firmly determined the choice of research topic.
Meanwhile, we suggested to DUT_China team member that human gene SNPs could be taken into consideration when predicting off-target loci. We also provided suggestions about data processing to help them solve the problem of data imbalance in the training set.


</p>
<br/><br/>
<Row>
      <Col md={{offset:1}}>
      <h2 style={{color:"#0072F9" ,fontWeight:"bold"}}>USTC_Software</h2>
      </Col>
      </Row>
      <br/>

<img src="https://static.igem.wiki/teams/4272/wiki/coll7.png" alt="coll5" 
      width={"1130vw"} style={{marginLeft:"10vw"}}/>
<br/><br/><br/><br/>
      <p style={{width:"85vw",marginLeft:"8vw"}}>
      On October 3, 2022, we had an online communication of projects with USTC_Software students. This year, USTC_Software focused on predicting enzymes with higher single-step reaction activity by reaction type based on existing databases, which is highly similar to our project.
During the discussion, we suggested that USTC_Software's project could take interactions and docking between reactants into account for enzyme selection. USTC_Software students pointed out that we should validate our project with examples such as experiments, rather than data from databases. These suggestions from each other really shed light on projects implementation for both sides. 
</p>
<br/>
<div id='problem_bg2'></div>
<Row>
      <Col md={{offset:1}}>
      <h2 style={{color:"#dedede" ,fontWeight:"bold"}}>SJTU_Software</h2>
      </Col>
      </Row>
      <br/>

<img src="https://static.igem.wiki/teams/4272/wiki/coll8.png" alt="coll5" 
      width={"1130vw"} style={{marginLeft:"10vw"}}/>
<br/><br/><br/><br/>
      <p style={{width:"85vw",marginLeft:"8vw"}}>
      On October 4, 2022, we had a meeting and exchanged ideas with SJTU_Software students online. After having a preliminary understanding of each other's projects, we had some discussions and reflections on each other’s projects. 
They questioned whether we could train a higher quality model with a small positive dataset when implementing training process, and we introduced the undersampling approach to them. We doubted the specific application of their project and learned more about the value of the actinomycete allogeneic metabolism model. 
By brainstorming with SJTU_Software students, we both reviewed our projects again and put forward further improvement.


</p>
<br/>
    </div>
  )
}

export default Collaborations
